import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllIndicadoresUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_indicadores_use_case";
import { DiarioObrasIndicadores } from "../../models/diarioobras_indicadores_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

export class GetAllIndicadoresUseCase
  extends BasePaginatedUseCase<DiarioObrasIndicadores>
  implements IGetAllIndicadoresUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }

  async getAllListagemIndicadores(): Promise<DiarioObrasIndicadores> {

    const response = await this.repository.getAllListagemIndicadores();
    return response;
  }
}
